// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomButton_root__9zpWq","ribbon":"CustomButton_ribbon__1HAFe"};